/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_ActionInputs */

const en_cognito_invitation_action = /** @type {(inputs: Cognito_Invitation_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access platform`)
};

const pt_br2_cognito_invitation_action = /** @type {(inputs: Cognito_Invitation_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessar plataforma`)
};

/**
* | output |
* | --- |
* | "Access platform" |
*
* @param {Cognito_Invitation_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_action = /** @type {((inputs?: Cognito_Invitation_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_action(inputs)
	return pt_br2_cognito_invitation_action(inputs)
});